import type { HostKind } from '../features/config/config-slice.js'
import { useSelector } from './selector.hook.js'

/** Where the SPA is running — see `AppConfig.hostKind` */
export const useHostKind = (): HostKind => useSelector(state => state.config.hostKind)

/**
 * True on a local kernel, which has none of the cloud's capabilities (push, the search
 * index, release-notes entities). Cloud-only features skip their requests on this rather
 * than answering a 501 on every page load.
 */
export const useIsLocalHost = (): boolean => useHostKind() === 'local'
